<app-breadcrumb [master]="'Kadry'" [parentName]="'Pracownicy'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group  (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedTab">
  <mat-tab label="Dane">
    <app-employee-details-view *ngIf="!modify"   (modifyClicked)="modify = true"  [user]="userObject" [employee]="employeeObject">    </app-employee-details-view>
<app-employee-details-form *ngIf="modify"  [user]="userObject" [employee]="employee" (closeModification)="modify = false; loadEmployee()">    </app-employee-details-form>
  </mat-tab>
<!--  <mat-tab label="Wnioski urlopowe">-->
<!--    <ng-template matTabContent>-->
<!--      <div fxLayout="column">-->
<!--        <div fxLayout="row">-->
<!--          <mat-form-field appearance="standard" class="view-select">-->
<!--            <mat-label>Rok</mat-label>-->
<!--            <mat-select [formControl]="leaveApplicationViewControl">-->
<!--              <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>-->
<!--            </mat-select>-->
<!--          </mat-form-field>-->
<!--        </div>-->
<!--        <app-leave-application-list [LeaveApplication]="leaveApplication" >    </app-leave-application-list>-->
<!--      </div>-->
<!--    </ng-template>-->
<!--  </mat-tab>-->

  <mat-tab label="Wnioski urlopowe">
    <ng-template matTabContent>
      <div fxLayout="column">
<!--        <div fxLayout="row">-->
<!--          <mat-form-field appearance="standard" class="view-select">-->
<!--            <mat-label>Rok</mat-label>-->
<!--            <mat-select [formControl]="leaveApplicationViewControl">-->
<!--              <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>-->
<!--            </mat-select>-->
<!--          </mat-form-field>-->
<!--        </div>-->
        <app-all-leave-application-list [employeeId]="employeeObject.uuid"  [disableBreadcrumb]="true" [embeddedView]="true">    </app-all-leave-application-list>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list  [employee]="employee"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>

